import $ from 'jquery'
import store from '@/store'
import { forEach, isNil, last, omitBy, set, find, startsWith, replace } from 'lodash'
import validate from 'validate.js'
import i18n from '@/resources/lang'

export default {

    // FORMAT NUMBER
    // Adds a comma after every third digits in Points Ledger and Status Bar
    // updated version based on the solution from
    // https://stackoverflow.com/questions/2901102
  formatNumber (value) {
    if (typeof value === 'undefined' || value === null) {
      return ''
    }
    let parts = value.toString().split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return parts.join('.')
  },

    /**
     * Return the dropdown labels using its value and the array of options
     *
     * @param value
     * @param {array} options
     * @return {string}
     */
  getDropdownLabel (value, options) {
    let option = find(options, { 'value': value })
    return (typeof option !== 'undefined' && 'label' in option) ? option.label : value
  },

    // POINTS LEDGER
    // The show/hide functionality for component.points-ledger
  togglePointsLedger (open) {
    if (open) {
      $('body').addClass('has-modal')
      $('.js-points-ledger').removeClass('is-hidden')
      $('.js-points-ledger').addClass('is-visible')
      $('.js-points-ledger-trigger').addClass('is-active')
    } else {
      $('body').removeClass('has-modal')
      $('.js-points-ledger').addClass('is-hidden')
      $('.js-points-ledger').removeClass('is-visible')
      $('.js-points-ledger-trigger').removeClass('is-active')
    }
  },

    // SHAKE ANIMATION
    // Adds shaking animation.
  shake (elem) {
    var el = elem
    el.addClass('shake')
    el.one('webkitAnimationEnd oanimationend msAnimationEnd animationend',
            function (e) {
              el.removeClass('shake')
            })
  },

    // HIGHLIGHT FIELD IF INVALID
    // Adds "is-not-valid" class to elements which have failed validation, and removes the
    // class as soon as the element gets focus.
    // Applies to the ForgotPassword/Login/ResetPassword components.
  highlight (id) {
    $('#' + id).addClass('is-not-valid')
            .removeClass('is-valid')
    $('#' + id).focus(function () {
      $(this).removeClass('is-not-valid')
    })
  },

    // SHOW PASSWORD
    // http://stackoverflow.com/questions/14305727/how-to-create-html-for-a-show-password-functionality
    // Automatically adds view password toggle on all fields with the input type="password".
  showPassword (field) {
    var passwordField = field || $('input[type="password"]')
    $(passwordField).each(function () {
      var className = this.id ? '_' + this.id : ''
      $(this)
                .wrap('<div class="c-password-field" />')
                .after('<a href="#" class="c-password-field__eye js-password-toggler' + className + ' tabindex="-1""></a>')
                .addClass('js-password-field')
                .addClass('is-encrypted')
                .siblings('.c-password-field__eye').addClass('t-password-eye')
    })
    var className = passwordField.attr('id') ? '_' + passwordField.attr('id') : ''
    $('.js-password-toggler' + className).click(function (e) {
      e.preventDefault()
      var $field = $(this).parent().find('input')
      if ($field.hasClass('is-encrypted')) {
        $field
                    .attr('type', 'text')
                    .addClass('is-not-encrypted')
                    .removeClass('is-encrypted')
                    .siblings('.c-password-field__eye').addClass('t-password-eye--active')
      } else {
        $field
                    .attr('type', 'password')
                    .addClass('is-encrypted')
                    .removeClass('is-not-encrypted')
                    .siblings('.c-password-field__eye').removeClass('t-password-eye--active')
      }
    })
  },

    // LOGIN CARD FUNCTIONS
    // Calls relevant functions for the Login Card
  initLoginCard (field) {
    this.showPassword(field)
  },

    // LOGGED IN
    // Returns true if the current user is logged into the app.
  isLoggedIn () {
    return localStorage.getItem('token_' + store.state.websiteConfig.id) !== null
  },

  isPasswordExpired () {
    return store.state.participant.is_password_expired
  },

    // REQUIRE AUTHENTICATION
    // This function is used when routing to pages which require authentication and would automatically
    // redirect to the login page if the user is not authenticated.
  requireAuth (router) {
    return (to, from, next) => {
      if (this.isLoggedIn()) {
        next()
      } else {
        router.push({ name: 'Login', params: { website: to.params.website } })
        next(false)
      }
    }
  },

  requireExpiredPassword (router) {
    return (to, from, next) => {
      if (this.isLoggedIn() && this.isPasswordExpired()) {
        next()
      } else {
        router.push({ name: 'Dashboard' })
        next(false)
      }
    }
  },

    // REQUIRE ENROLLMENT
    // This function is used when routing to pages which require platform enrollment to be enablled
    // and would automatically redirect to a Not Found page if the platform doesn't allow enrollment.
  requireEnrollment (router) {
    return (to, from, next) => {
      if (store.state.websiteConfig.enrollment_enabled) {
        next()
      } else {
        router.push({ name: 'NotFound', params: { website: to.params.website } })
        next(false)
      }
    }
  },

    // REDIRECT TO DASHBOARD
    // IF a user is already logged in and tries to access the login page they are automatically
    // redirected to the Dashboard.
  redirectIfLoggedIn (router) {
    return (to, from, next) => {
      if (this.isLoggedIn()) {
        router.push({ name: 'Dashboard', params: { website: to.params.website } })
        next(false)
      } else {
        next()
      }
    }
  },

  validatePassword (value) {
    var exp = /^(?=.*\d)(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*_]{12,}$/g
    var reg = new RegExp(exp)
    if (value.match(reg)) {
      return true
    }
    return false
  },

  validateForm (elem, standardFormFields, customFormFields, formValues, constraints, options) {
    var formErrors = {}
    let valid = true
    let errors = validate(formValues, constraints, options)
    forEach(standardFormFields, (field, i) => {
      if (errors && errors[field]) {
        formErrors[field] = errors[field]
                    // Trying to keep consistency and use selector only by name, not by id
                    // how it was previously, and do it as the other validation functions
                    // do in this file
        $(elem).find('[name="' + field + '"]').addClass('is-not-valid')
        valid = false
      }
    })

    var validation = this.validateFields(elem, customFormFields, formValues)
    valid = validation.valid === false ? false : valid

    var errorsMerged = {}
    if (errors) {
      Object.keys(errors).forEach((key) => {
        errorsMerged[key] = []
        errorsMerged[key].push(errors[key][0])
      })
    }
    Object.keys(validation.errors).forEach((key) => {
      if (typeof errorsMerged[key] === 'undefined') {
        errorsMerged[key] = []
      }
      errorsMerged[key].push(validation.errors[key])
    })

    return { valid: valid, errors: errorsMerged }
  },

  handleResponseErrors (elem, errors) {
    var messages = {}
    for (var field in errors) {
      $(elem).find('[name="' + field + '"] input').addClass('is-not-valid')
      messages[field] = errors[field]
    }
    return messages
  },

  validateFields (el, formFields, formValues) {
    let valid = true
    let errors = {}
    forEach(formFields, (field, i) => {
      var input = $(el).find('[name="' + field.name + '"] input')
      let error = this.validateField(field, formValues[field.name], input[0])
      if (error !== '') {
        errors[field.name] = error
                    // var input above already have the element we need, there's no need
                    // to find and select the element again
        input.addClass('is-not-valid')
        valid = false
      }
    })
    return { valid: valid, errors: errors }
  },

  validateField (field, value, input) {
    let error = ''
            // check the html5 validation first since the model value might not be set for invalid currency/integer fields
    if (['integer', 'currency', 'decimal', 'percent', 'date'].includes(field.type)) {
      error = input === undefined ? '' : input.validationMessage
      if (field.type === 'date' && error !== '') {
                // chrome treats an invalid date (02/31/2007) as empty.  Need to check the input
                // validationMessage to determine if its invalid or just empty.
        error = i18n.t('utils.validation.date_format', { attribute: field.label, format: 'MM/DD/YYYY' })
      } else if (['integer', 'currency', 'decimal', 'percent'].includes(field.type) && (value || value === 0)) {
                // IE returns valid for things like '1....ee.e.e..ee1' with numberValue being NaN
                // for empty values it also returns NaN in numberValue but the string value itself would be empty

        const validators = {
          integer: {
            expr: /^([0]|-?[1-9][0-9]{0,9})?$/,
            messageKey: 'utils.validation.integer_invalid'
          },
          currency: {
            expr: /^([0]|-?[1-9][0-9]{0,7})(\.\d{1,2})?$/,
            messageKey: 'utils.validation.currency_invalid'
          },
          decimal: {
            expr: /^([0]|-?[1-9][0-9]{0,12})(\.\d{0,13})?$/,
            messageKey: 'utils.validation.decimal_invalid'
          },
          percent: {
            expr: /^([0]|-?[1-9][0-9]{0,13})(\.\d{0,13})?$/,
            messageKey: 'utils.validation.percent_invalid'
          }
        }

        if (!validators[field.type].expr.test(value)) {
          error = i18n.t(validators[field.type].messageKey)
        } else if (['decimal', 'percent'].includes(field.type) && value) {
          error = ''
        }
      }
    }
    if (field.required && (field.type === 'bool' || error === '') && !value) {
      error = i18n.t('utils.validation.required', { attribute: field.label })
    }

    if (field.type === 'email' && value) {
      let errors = validate({ 'email': value }, {
        'email': {
          'email': {
            message: i18n.t('utils.validation.email')
          }
        }
      }, { 'fullMessages': false, 'format': 'flat' })
      if (errors) {
        error = errors[0].replace('{attribute}', field.label)
      }
    }
    return error
  },

  addRoutes (router, routes, isVanityUrl) {
    if (isVanityUrl) {
      router.addRoutes(routes)
    } else {
      router.addRoutes([{
        path: '/:website',
        component: {
          render (c) { return c('router-view') }
        },
        children: routes
      }])
    }
  },

  addImageLinksForMobile (platformImages) {
    this.addImageLinkToDocumentHead('apple-touch-icon', platformImages.apple_touch_icon, false, 'apple-icon')
    this.addImageLinkToDocumentHead('icon', platformImages.favicon_android, false, 'android-icon')
    this.addImageLinkToDocumentHead('icon', platformImages.favicon_android, '192x192', 'android-icon-192')
    this.addImageLinkToDocumentHead('icon', platformImages.favicon_android, '128x128', 'android-icon-128')
  },

  addImageLinkToDocumentHead (rel, href, sizes, id) {
    var link = document.createElement('link')
    link.type = 'image/png'
    link.rel = rel
    link.href = href
    link.id = id
    if (sizes) {
      link.sizes = sizes
    }
    document.head.appendChild(link)
  },
  removePlatformSpecificHeaderElements () {
    $('link[rel=stylesheet][title=custom_css]').prop('disabled', true)
    $('#apple-icon').prop('disabled', true)
    $('#android-icon').prop('disabled', true)
    $('#android-icon-192').prop('disabled', true)
    $('#android-icon-128').prop('disabled', true)
    $('link[rel=stylesheet][title=custom_css]').remove()
    $('#apple-icon').remove()
    $('#android-icon').remove()
    $('#android-icon-192').remove()
    $('#android-icon-128').remove()
  },

  addCustomCssFile (websiteConfig) {
    var href = ''
    if (websiteConfig.custom_platform_css_file) {
      href = process.env.API_URL + '/' + websiteConfig.custom_platform_css_file
      $('<link/>', { rel: 'stylesheet', title: 'custom_css', href: href }).appendTo('head')
    }
    if (websiteConfig.custom_program_css_files) {
      for (var customProgramCssFile of websiteConfig.custom_program_css_files) {
        href = process.env.API_URL + '/' + customProgramCssFile
        $('<link/>', { rel: 'stylesheet', title: 'custom_css', href: href }).appendTo('head')
      }
    }
  },

  updateWebsiteTitle (title) {
    document.title = title
  },

    /**
     * Sets the platform localization strings
     * @param lang Object
     */
  addPlatformLanguage (lang) {
    if (typeof lang !== 'undefined') {
      let localeMessages = i18n.getLocaleMessage('en-US')
      forEach(lang, (value, key) => {
        set(localeMessages, key, value)
      })
      i18n.setLocaleMessage('en-US', localeMessages)
    }
  },

  closeModals () {
    $('body').removeClass('has-modal')
    store.commit('UPDATE_CLAIM_MODAL_SHOW', false)
  },

  getDataToBeSaved (fields, model) {
    let data = {}
    forEach(fields, (field, i) => {
      data[field.name] = this.formatFieldValueForApi(field, model[field.name])
    })
    return data
  },

  formatFieldValueForApi (field, value) {
        // undefined values won't be included on the payload, so setting to null
    if (typeof value === 'undefined') {
      value = null
    }

    switch (field.type) {
            // need to format dates to be consistent accross all the browsers.  the
            // Api expects date format to be givin in YYYY-MM-DD.  Any other format
            // going across the Api should be stopped by the server-side validation
      case 'date':
        if (/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(value)) {
          let dateParts = value.split('/')
          let month = dateParts[0]
          let day = dateParts[1]
          let year = dateParts[2]
          value = [year, month, day].join('-')
        }
        break
      case 'bool':
        if (value === null) {
          value = 0
        }
        break
    }
    return value
  },

  logoutFromBrowser (commit, router, websiteId) {
    localStorage.removeItem('token_' + websiteId)
    localStorage.removeItem('impersonate_' + websiteId)
    commit('UPDATE_LOGIN_STATUS', false)
    commit('UPDATE_PARTICIPANT', {
      first_name: '',
      last_name: ''
    })
    window.location.href = router.resolve('login').href
  },

  getPagination (current, last) {
    let pages = []
    let first = 1
    let distance = 2
    if (last <= 5) {
      for (let i = 1; i <= last; i++) {
        pages.push(i)
      }
      return pages
    }
    if (current - first <= distance) {
      for (let i = first; i <= first + distance; i++) {
        pages.push(i)
      }
    } else if (current - first > distance) {
      pages.push(first)
      pages.push('...')
    }
    if (current !== first && current !== last) {
      for (let i = current - 1; i <= current + 1; i++) {
        if (pages.indexOf(i) === -1) {
          pages.push(i)
        }
      }
    }
    if (last - current <= distance) {
      for (let i = last - distance; i <= last; i++) {
        if (pages.indexOf(i) === -1) {
          pages.push(i)
        }
      }
    } else if (last - current > distance) {
      pages.push('...')
      pages.push(last)
    }
    return pages
  },

    // This function calculates how many of each claim type should
    // appear on the submitter and approver claim cards. It returns
    // an array full of object pages indexed at there page number
    // (map[1] equals page #1.)
    //
    // Each page looks like this:
    // {
    //   pageNumber: 1,
    //   topGroupCount: 3,
    //   topGroupStart: 0,
    //   bottomGroupCount: 7,
    //   bottomGroupStart: 0
    // }
    //
    // Given this information we know exactly how many of each claim
    // type are on a given page and which ones to display. The 'start'
    // attributes are the index to start displaying them.
    //
  getPageMap (perPageCount, pages, topGroup, bottomGroup) {
    let map = []

        // because of how we are handling pagination, the pages array
        // can have ellipses in it like this this [1, 2, 3, '...', 12]
        // so just take the last page and use that to iterate
    let pageCount = last(pages)

    for (let pageNumber = 1; pageNumber <= pageCount; pageNumber++) {
      let topGroupCount = 0
      let bottomGroupCount = 0
      let bottomGroupMax = 0

            // set the top group
      if (topGroup >= perPageCount) {
        topGroupCount = perPageCount
        topGroup -= perPageCount
        bottomGroupMax = 0
      } else if (topGroup < perPageCount) {
        topGroupCount = topGroup
        topGroup = 0
        bottomGroupMax = perPageCount - topGroupCount
      }

            // set the bottom group
      if (bottomGroup >= bottomGroupMax) {
        bottomGroupCount = bottomGroupMax
        bottomGroup -= bottomGroupMax
      } else if (bottomGroup < bottomGroupMax) {
        bottomGroupCount = bottomGroup
        bottomGroup = 0
      }

      let page = {
        pageNumber: pageNumber,
        topGroupCount: topGroupCount,
        bottomGroupCount: bottomGroupCount
      }

      map[pageNumber] = page

      if (pageNumber === 1) {
        map[pageNumber].topGroupStart = 0
        map[pageNumber].bottomGroupStart = 0
      } else {
        let previous = pageNumber - 1
        map[pageNumber].topGroupStart = (map[pageNumber].topGroupCount === 0) ? 0 : map[previous].topGroupCount + map[previous].topGroupStart
        map[pageNumber].bottomGroupStart = (map[pageNumber].bottomGroupCount === 0) ? 0 : map[previous].bottomGroupCount + map[previous].bottomGroupStart
      }
    }

    return omitBy(map, isNil)
  },

  getParticipantPosition (id, records) {
    for (let i = 0; i < records.length; i++) {
      if (records[i][0].id === id) {
        return i
      }
    }
    return null
  },

  triggerFileDownload (data, filename, downloadType, forceDownload = false) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
    let blob = new Blob([data], { type: downloadType })
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveBlob && window.navigator.msSaveOrOpenBlob) {
      if (forceDownload) {
        window.navigator.msSaveBlob(blob, filename)
      } else {
        window.navigator.msSaveOrOpenBlob(blob, filename)
      }
    } else {
            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
      let data = window.URL.createObjectURL(blob)
      let link = window.document.createElement('a')
      link.setAttribute('href', data)
      if (forceDownload) {
        link.setAttribute('download', filename)
      } else {
        link.setAttribute('target', '_blank')
      }
      document.body.appendChild(link)
      link.click()
      setTimeout(function () {
        document.body.removeChild(link)
                    // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data)
      }, 100)
    }
  },

    /**
     * Handle a url click event and call Vue router if the url is pointing to another route
     * within the same website to avoid reloading the whole applicate, otherwise a normal
     * browser navigation/reload would occur
     *
     * @return {void}
     */
  handleLink (e, websiteConfig, router) {
    let baseUrl = websiteConfig.vanity_url
            ? window.location.protocol + '//' + websiteConfig.external_url + '/'
            : window.location.protocol + '//' + window.location.hostname + '/' + websiteConfig.url
    if (startsWith(e.currentTarget.href, baseUrl)) {
      e.preventDefault()
      let url = websiteConfig.vanity_url
                ? '/' + replace(e.currentTarget.href, baseUrl, '')
                : '/' + websiteConfig.url + replace(e.currentTarget.href, baseUrl, '')
      router.push(url)
    }
  }

}



// WEBPACK FOOTER //
// ./src/functions.js